<template>
  <div>
    <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
      <v-breadcrumbs-item
        v-for="item in navSettingsOptions"
        :key="item.index"
        @click='() => {
          if (item.to) $router.push(item.to)
        }'
        :class='[
          item.to ? "cursor-pointer" : "cursor-default"
        ]'
      >
        <span
          class="text-breadcum-settings"
        >
          {{ item.text }}
          <v-icon style="font-size: 1.2rem">mdi-chevron-right</v-icon>
        </span>
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <div class='mt-4 integration__sync__stepper table-wrapper'>
      <div class='integration__sync__stepper__header px-4'>
        <h6>Sync log of the "<b>SmartTech</b>" with QuickBooks</h6>
        <v-spacer />
        <filter-by-period
          :dateFromDefault='datePeriodFilterFrom'
          :dateToDefault='datePeriodFilterTo'
          @on-change='handleDatePeriodChange'
        />
      </div>
      <v-data-table
        :headers="headers"
        :items="filtredByPeriodItems"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :item-class='computedLogsItemClass'
        hide-default-footer
      >
        <template v-slot:[`item.updatedAt`]='{ item }'>
          <div class='flex flex-column align-center float-left'>
            <span>{{item.updatedAt | formatDateToDay(dateTimeFormat)}}</span>
            <span class='text-grey-7'>{{item.updatedAt | formatDateToTime(dateTimeFormat)}}</span>
          </div>
        </template>
        <template v-slot:[`item.status`]='{ item }'>
          <div v-if='item.status === "SUCCESS"'>
            <v-icon
              size='16'
              color='#00962b'
            >
              mdi-check-bold
            </v-icon>
            <span class='ml-1 font-weight-bold' style='color: #00962b'>success sync</span>
          </div>
          <div v-else-if='item.status === "RESOLVED"'>
            <v-icon
              size='16'
              color='#0185da'
            >
              mdi-check-bold
            </v-icon>
            <span class='ml-2 font-weight-bold' style='color: #0185da'>conflicts resolved</span>
          </div>
          <div v-else>
            <v-icon
              size='16'
              color='#ce0817'
            >
              mdi-alert-outline
            </v-icon>
            <span class='ml-2 font-weight-bold' style='color: #ce0817'>error sync</span>
          </div>
        </template>
        <template v-slot:[`item.categoriesAdded`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.categoriesAdded }}</span>
        </template>
        <template v-slot:[`item.itemsAdded`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.itemsAdded }}</span>
        </template>
        <template v-slot:[`item.categoriesChanged`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.categoriesChanged }}</span>
        </template>
        <template v-slot:[`item.itemsChanged`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.itemsChanged }}</span>
        </template>
        <template v-slot:[`item.categoriesDeleted`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.categoriesDeleted }}</span>
        </template>
        <template v-slot:[`item.itemsDeleted`]='{ item }'>
          <span v-if='$checkEqualityStrings(item.status, "SUCCESS")'>{{ item.itemsDeleted }}</span>
        </template>
        <template v-slot:[`item.actions`]='{ item }'>
          <router-link
            v-if='$checkEqualityStrings(item.status, "ERROR")'
            :to='{
              name: "IntegrationResolve",
              params: { id: $route.params.id }
            }'
          >
            <v-img
              lazy-src='@/assets/icons/svg/foreign.svg'
              src='@/assets/icons/svg/foreign.svg'
              max-width='26'
            />
          </router-link>
        </template>
      </v-data-table>
      <v-container style='background-color: #f5f5f5'>
        <v-row class="pagination-wrapper">
          <v-col cols="5">
            <span class="text-nowrap mr-2">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  style="padding: 0; font-weight: 600"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in itemsPerPageOptions"
                  :key="index"
                  link
                  @click="itemsPerPage = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="7" class="d-flex justify-end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="5"
              color="#7972C0"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import service from '@/services/integrations'
import filterByPeriod from '@/views/reports/ReportStockBalancesRange/components/FilterByPeriod'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'IntegrationsLog',
  data: () => ({
    navSettingsOptions: [
      {
        index: 1,
        text: 'Integrations',
        to: {
          name: 'IntegrationAllSyncs'
        }
      },
      {
        index: 2,
        text: 'Log'
      }
    ],
    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'updatedAt',
        width: 120
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false,
        align: 'start'
      },
      {
        text: 'Note',
        value: 'description',
        sortable: false,
        align: 'start'
      },
      {
        text: 'Add\nFolders',
        value: 'categoriesAdded',
        sortable: false,
        align: 'center',
        width: 100
      },
      {
        text: 'Add\nItems',
        value: 'itemsAdded',
        sortable: false,
        align: 'center',
        width: 90
      },
      {
        text: 'Changed\nFolders',
        value: 'categoriesChanged',
        sortable: false,
        align: 'center',
        width: 100
      },
      {
        text: 'Changed\nItems',
        value: 'itemsChanged',
        sortable: false,
        align: 'center',
        width: 100
      },
      {
        text: 'Deleted\nFolders',
        value: 'categoriesDeleted',
        sortable: false,
        align: 'center',
        width: 100
      },
      {
        text: 'Deleted\nItems',
        value: 'itemsDeleted',
        sortable: false,
        align: 'center',
        width: 100
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'center',
        width: 100
      }
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    itemsPerPageOptions: [5, 10, 20, 25, 50],
    datePeriodFilter: {
      from: null,
      to: null
    }
  }),
  computed: {
    ...mapGetters('user', {
      dateTimeFormat: 'getDateTimeFormat'
    }),
    datePeriodFilterFrom: {
      get() {
        return this.datePeriodFilter.from || null
      },
      set(v) {
        this.datePeriodFilter.from = moment(v).format('YYYY-MM-DD')
      }
    },
    datePeriodFilterTo: {
      get() {
        return this.datePeriodFilter.to || null
      },
      set(v) {
        this.datePeriodFilter.to = moment(v).format('YYYY-MM-DD')
      }
    },
    filtredByPeriodItems() {
      return this.items.filter(item => {
        const itemDate = moment(item.updatedAt).format('YYYY-MM-DD')
        if (this.datePeriodFilterFrom && this.datePeriodFilterTo) {
          if (moment(this.datePeriodFilterFrom).isSame(this.datePeriodFilterTo)) {
            return moment(itemDate).isSame(this.datePeriodFilterFrom)
          } else {
            return moment(itemDate).isSameOrAfter(this.datePeriodFilterFrom) && moment(itemDate).isSameOrBefore(this.datePeriodFilterTo)
          }
        }
        if (this.datePeriodFilterFrom) return moment(itemDate).isSameOrAfter(this.datePeriodFilterFrom)
        if (this.datePeriodFilterTo) return moment(itemDate).isSameOrBefore(this.this.datePeriodFilterTo)
        return true
      })
    }
  },
  filters: {
    formatDateToDay(v, format) {
      return moment(v).format(format).split(' ')[0]
    },
    formatDateToTime(v, format) {
      return moment(v).format(format).split(' ')[1]
    }
  },
  methods: {
    computedLogsItemClass(item) {
      if (this.$checkEqualityStrings(item.status, 'SUCCESS')) return 'logs-success-row'
      if (this.$checkEqualityStrings(item.status, 'ERROR')) return 'logs-error-row'
      return 'logs-resolvedItem-row'
    },
    handleDatePeriodChange(payload) {
      this.datePeriodFilterFrom = payload.dateFrom
      this.datePeriodFilterTo = payload.dateTo
    }
  },
  async created() {
    if (!isNaN(+this.$route.params.id)) {
      const response = await service.getLogs({ inventoryId: +this.$route.params.id })
      this.items = response.data.data
    } else {
      this.$router.replace({ name: 'IntegrationAllSyncs' })
    }
  },
  components: {
    filterByPeriod
  }
}
</script>

<style scoped lang="scss">
  .integration__sync__stepper {
    border: 1px solid rgba(grey, 0.35);
    border-radius: 8px;
    box-shadow: none;
    &__header {
      display: flex;
      align-items: center;
      height: 60px;
      background-color: #f5f5f5;
      box-shadow: none;
      border-bottom: 1px solid rgba(grey, 0.35);
    }
  }
  ::v-deep .logs-success-row {
    background-color: rgba(#00962a, 0.15);
    transition: linear 0.1s;
  }
  ::v-deep .logs-error-row {
    background-color: rgba(#d51112, 0.15);
    transition: linear 0.1s;
  }
  ::v-deep .logs-resolvedItem-row {
    background-color: rgba(#0185da, 0.15);
    transition: linear 0.1s;
  }
</style>
